import {match} from 'path-to-regexp';
import {ParametricSelector} from 'reselect';

/*
 * Types.
 */

export interface PanelRouteProps {
  // TODO: Use io-ts to strongly type this.
  params: any;
  search: string;
}

export interface PanelRoute<S, T> {
  path: string;
  getParameters: ParametricSelector<S, PanelRouteProps, T>;
}

/*
 * Helpers.
 */

export function buildRouter<S, T>(routes: readonly PanelRoute<S, T>[]) {
  const compiledRoutes = routes.map((route) => ({
    ...route,
    match: match(route.path, {end: false}),
  }));

  return (state: S, pathname: string, search: string = '') => {
    for (let i = 0; i < compiledRoutes.length; i++) {
      const route = compiledRoutes[i];
      const result = route.match(pathname);
      if (!result) {
        continue;
      }

      const {params} = result;
      return route.getParameters(state, {params, search});
    }

    return false;
  };
}
